<template>
  <v-app>
    <FrameAuth></FrameAuth>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer elevation="5" absolute height="80" color="white">
        <v-col></v-col>
        <v-col class="text-center"><h4 class="font-weight-light">Synoptyx Inc. &copy; - 2019 </h4></v-col>
        <v-col class="text-end"><img src="./assets/Synoptyx_logo.svg" height="60"></v-col>
     </v-footer>
  </v-app>
</template>

<script>
import FrameAuth from './components/frame/FrameAuth';

export default {
    name: 'App',

    components: {
        FrameAuth
    },

    data() {
        return {

        }
    },
    methods: {

    },
}
</script>

<style scoped>

.custom-placeholder-color input::placeholder{
color:red;
opacity:1
}
</style>
